export default __webpack_public_path__ + "static/media/Idle.818ea3b5.png";